import { MOBILE_TERMINAL_ID_STORAGE_KEY, MOBILE_TERMINAL_SERIAL_NO_STORAGE_KEY } from 'constants/user';
import config from 'utils/config';

const sptmUrl = config('TERMINAL_MAPPER_PROXY_URL');

export const getSptmConfig = async () => {
  // retrieve terminal info from local storage, if present
  if (localStorage.getItem(MOBILE_TERMINAL_ID_STORAGE_KEY)) {
    const TERMINAL_ID = localStorage.getItem(MOBILE_TERMINAL_ID_STORAGE_KEY);
    const TERMINAL_SERIAL_NO = localStorage.getItem(MOBILE_TERMINAL_SERIAL_NO_STORAGE_KEY);

    return { TERMINAL_ID, TERMINAL_SERIAL_NO };
  }

  // retrieve terminal info frpm sptm service if mobile not synced
  const response = await fetch(sptmUrl);

  if (!response.ok) {
    throw new Error('SPTM Connection Error: Failed to retrieve SPTM configuration file');
  }

  return response.json();
};
